import type { IconDefinition } from '../index.tsx';

export const iconGlobe: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconGlobe',
  icon: [
    16,
    16,
    [],
    '',
    'M0.0620117 9C0.232589 10.3679 0.748522 11.6286 1.51981 12.692C1.56141 12.6687 1.60356 12.6454 1.64627 12.6221C3.13164 11.8119 5.29563 11 8.00012 11C10.7046 11 12.8686 11.8119 14.354 12.6221C14.3967 12.6454 14.4388 12.6687 14.4804 12.692C15.2517 11.6286 15.7676 10.3679 15.9382 9L0.0620117 9Z M8.00012 16C6.08224 16 4.32199 15.3251 2.9439 14.1999C4.18875 13.5745 5.90261 13 8.00012 13C10.0976 13 11.8115 13.5745 13.0563 14.1999C11.6782 15.3251 9.918 16 8.00012 16Z M2.94388 1.80013C4.32198 0.674886 6.08223 0 8.00012 0C9.91799 0 11.6782 0.674878 13.0563 1.80011C11.8115 2.42547 10.0976 2.99999 8.00009 2.99999C5.90259 2.99999 4.18874 2.42549 2.94388 1.80013Z M1.51979 3.30803C1.56139 3.33131 1.60354 3.3546 1.64624 3.37789C3.13161 4.18809 5.2956 4.99999 8.00009 4.99999C10.7046 4.99999 12.8686 4.18809 14.3539 3.37789C14.3967 3.35459 14.4388 3.33129 14.4804 3.308C15.2517 4.37141 15.7676 5.63208 15.9382 7L0.0620117 7C0.232588 5.63209 0.748517 4.37143 1.51979 3.30803Z',
  ],
};
